exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: colmo) {\n.line-box {\n    width: 0.05333rem;\n    border-radius: 0px;\n}\n.active-box {\n    width: 0.05333rem;\n    padding-left: 0px;\n}\n}", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-side-nav/colmo.css"],"names":[],"mappings":";AAAA;AACE;IACE,kBAAW;IACX,mBAAmB;CACpB;AACD;IACE,kBAAW;IACX,kBAAkB;CACnB;CACF","file":"colmo.css","sourcesContent":["@media screen and (weex-theme: colmo) {\n  .line-box {\n    width: 4px;\n    border-radius: 0px;\n  }\n  .active-box {\n    width: 4px;\n    padding-left: 0px;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20a171e8","scoped":false,"hasInlineConfig":false}!./packages/dof-side-nav/colmo.css
// module id = 151
// module chunks = 0 1